import React from "react";
import { useDispatch, useSelector } from "react-redux";

// UTILS
import { openUserOpenCashier } from "../../utils/cashier";
// REDUX
import { updateOrders } from "../../store/actions/ordersSlice";
import { setShowCashierInfosModal } from "../../store/actions/cashierSlice";
//APP COMPONENTS
import CashierInfoModal from "./cashierInfoModal";
import CreateCashierModal from "./CreateCashierModal";
import { isOwner } from "../../common/validators";
// MATERIAL UI

export default function CashierManager() {
  const dispatch = useDispatch();

  const userType = useSelector((state) => state.auth.user?.user_type);

  const showNewCashierModal = useSelector(
    (state) => state.cashier.showNewCashierModal
  );
  const showCashierInfosModal = useSelector(
    (state) => state.cashier.showCashierInfosModal
  );

  const handleShowCashierInfosModal = () => {
    dispatch(setShowCashierInfosModal(!showCashierInfosModal));
    dispatch(updateOrders({}));
  };

  return (
    <>
      {showNewCashierModal && !isOwner(userType) && (
        <CreateCashierModal
          show={showNewCashierModal}
          create={openUserOpenCashier}
        />
      )}

      {showCashierInfosModal && (
        <>
          <CashierInfoModal
            show={showCashierInfosModal}
            closeModal={handleShowCashierInfosModal}
          />
        </>
      )}
    </>
  );
}
